































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Field, ActionSheet, Tab, Tabs, Calendar, Empty, List, PullRefresh } from "vant";
import workService from "@/service/workService";
import * as _ from "lodash";
import { OrderEntity } from "@/model/Order";
import { WorkTaskModel, WorkTaskEntity } from "@/model/Work";
import { BusinessType } from "@/model/Base";
import { parseOrder } from "@/views/order/orderUtils";
@Component({
  name: "flightCard",
  components: {
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Calendar.name]: Calendar,
    [Empty.name]: Empty,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class FlightCard extends Vue {
  //data
  isUserFlight = false;
  isSearchFlight = false;
  activeTab = "city";

  DepartCityName = "上海";
  ArriveCityName = "北京";
  DepartDate = new Date();

  internalFlightList: any = [];
  overseasFlightList = [];

  changeStatus = "pick";
  changePickUp(key: string) {
    let __self = this;
    __self.changeStatus = key;
  }

  formatDate(value: Date, format: string = this.$root.$t("mall_flight_flight_yueri") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }

  City: any = "";
  selectCode = "";
  selectCity(cityType: string) {
    this.City = null;
    this.selectCode = cityType;
    this.$router.push({
      path: "/selectCity",
      query: {
        // ServiceType: this.query.ServiceType,
        // ApplyArea: this.query.ApplyArea + "",
      },
    });
  }

  datePickerVisible = false;
  timeSelect(value: string) {
    this.datePickerVisible = true;
  }

  changeCityFlag = false;
  changeCity() {
    this.changeCityFlag = !this.changeCityFlag;
    const newArriveCityName = this.ArriveCityName;
    this.ArriveCityName = this.DepartCityName;
    this.DepartCityName = newArriveCityName;
  }

  goToUserFlight() {
    this.isUserFlight = true;
    this.loadWorks();
  }

  model: any = {
    PageNo: 0,
    PageSize: 15,
    RecordCount: 15,
    BusinessTypes: [1797, 1789],
    ServiceTypes: [1409],
  };
  loadWorks() {
    let __self = this;
    workService.List(__self.model).then((json: any) => {
      if (json.isSucc) {
        if (json.result.entities.length < 1) {
          // this.loading = false;
          if (this.internalFlightList.length > 0) {
            // this.finished = true;
            if (json.result!.PageNo === 1) {
              // this.isEmptyState = true;
              this.internalFlightList = [];
            }
            return;
          } else {
            // this.finished = true;
            this.internalFlightList = [];
            // this.isEmptyState = true;
            return;
          }
        }
        handleArr(json);
      }
    });
    function handleArr(json: any) {
      // __self.loading = false;
      let works = json.result!.entities!;
      // __self.model.RecordCount = json.result!.recordCount!;
      let order: any = {};
      let orderWorks = _.orderBy(works, (o: OrderEntity) => o.OrderID, "desc");
      let cleanOrders = _.remove(orderWorks as any, (o: WorkTaskEntity) => o.ServiceType == 1410 || o.ServiceType == 1466);
      for (var i = 0; i < orderWorks.length; i++) {
        var ent = orderWorks[i] as any;
        if (!ent || ent.TripOrder || ent.BusinessType != BusinessType.Sales) {
          continue;
        }
        ent.Products = parseOrder(ent);

        let orderInstance = ent.TripOrder || ent.TourOrder;
        if (!orderInstance) {
          for (var m = 0; m < cleanOrders.length; m++) {
            if (cleanOrders[m].UnionID == ent.UnionID && ent.UnionID && ent.UnionID != "") {
              ent.ReceiveAmount += (cleanOrders[m] as any).ReceiveAmount;
            }
          }
          orderInstance = ent;
        }
        if (!order[orderInstance.OrderID]) {
          order[orderInstance.OrderID] = [];
        }
        order[orderInstance.OrderID].push(ent);
        order[orderInstance.OrderID] = _.orderBy(order[orderInstance.OrderID], o => o.UniqueID);
      }
      if (__self.model.PageNo == 1) {
        //清空数组
        __self.internalFlightList.splice(0, __self.internalFlightList.length);
      }
      for (const key in order) {
        if (order.hasOwnProperty(key)) {
          let newOrders = order[key];
          let isNewOrder = true;
          for (let i = 0; i < __self.internalFlightList.length; i++) {
            let ctxOrders = __self.internalFlightList[i];
            if (ctxOrders[0].OrderID == key) {
              __self.internalFlightList[i] = newOrders;
              isNewOrder = false;
              break;
            }
          }
          if (isNewOrder) {
            __self.internalFlightList.push(newOrders);
          }
        }
      }
      // __self.isPullLoading = false;
    }
  }
}
